import axios from "axios"
import api from './../api/api'
import qs from "qs"
import { message } from 'antd'

//let base = "https://version-czytest.colourlife.com/yunconsole";

 var url = document.domain,_baseUrl
// if (!url || url.indexOf('test') !== -1 || url === 'localhost') {
//     _baseUrl = "https://lekaiadminapi-doortest.colourlife.com"
// } else if (url === "yun-beta.colourlife.com" || url.indexOf('beta') !== -1) { //预发环境
//     _baseUrl = "https://lekaiadminapi-doorbeta.colourlife.com"
// } else {
//     _baseUrl = "https://lekaiadminapi-door.colourlife.com"
// }

// if (!url || url.indexOf('test') !== -1 || url === 'localhost') {
//     _baseUrl = "https://version-czytest.colourlife.com/yunconsole"
// } else if (url === "yun-beta.colourlife.com" || url.indexOf('beta') !== -1) { //预发环境
//     _baseUrl = "https://lekaiadminapi-doorbeta.colourlife.com"
// } else {
//     _baseUrl = "https://lekaiadminapi-door.colourlife.com"
// }

// if(url==='frontend-versiontest.colourlife.com'){
//     _baseUrl='https://version-czytest.colourlife.com/yunconsole'
// }else{
//     _baseUrl='https://version.colourlife.com/yunconsole'
// }


if(url === "frontend-versiontest.colourlife.com"){
    _baseUrl="https://version-czytest.colourlife.com/yunconsole"
}else if(url === "frontend-version.colourlife.com"){
    _baseUrl= "https://version.colourlife.com/yunconsole"
}else{
    _baseUrl="https://version-czytest.colourlife.com/yunconsole"
}

// if(url==='wei-czy.colourlife.com'){
//     _baseUrl='https://qrcode.colourlife.com/'
// }else{
//     _baseUrl='https://qrcode-czytest.colourlife.com/'
// }
//响应拦截
axios.interceptors.response.use(function (response) {

    if (response.data.code === 400) {

        window.location.href = api._baseUrl + '/#/login';

        localStorage.clear();
        //console.log(111)
        //message.error(response.data.message);

    }

    if (response.data.code !== 0) {

        //message.error(response.data.message);

    }

    return response;

}, function (error) {

    // Do something with response error  
    return Promise.reject(error)

})
export default {
    _baseUrl,
    //公共二维码列表
    // getQrcodeList: params => {
    //     return axios.get(`${_baseUrl}new/backend/qrcode/list`, {
    //         params: params
    //     }).then(res => res.data)
    // },
    //编辑公共二维码
    // updateEWM: params => {
    //     return axios.post(`${_baseUrl}new/backend/qrcode/common/update`, qs.stringify(params)).then(res => res.data)
    // },

    //获取app列表
    appList: params => {
        return axios.get(`${_baseUrl}/app/list`, {
            params: params
        }).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //获取发版管理列表
    managementList: params => {
        return axios.get(`${_baseUrl}/version/list`, {
            params: params
        }).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //获取组织架构搜索
    architectureSearch: params => {
        return axios.get(`${_baseUrl}/org/search`, {
            params: params
        }).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //获取租户搜索
    tenantSearch: params => {
        return axios.get(`${_baseUrl}/corp/search`, {
            params: params
        }).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //文件上传
    // fileUpload: params => {
    //     return axios.post(`${_baseUrl}/file/upload`, qs.stringify(params)).then(response => {
    //         // 返回后端返回数据
    //         return response.data
    //     }).catch(error => {
    //         // 异常处理
    //         message.error("服务器开小差了⊙﹏⊙∥");
    //     })
    // },
    //获取版本详情
    versionDetails: params => {
        return axios.get(`${_baseUrl}/version/detail`, {
            params: params
        }).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //新增版本信息
    versionInformation: params => {
        return axios.post(`${_baseUrl}/version/create`, qs.stringify(params)).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //编辑版本
    compiler: params => {
        return axios.post(`${_baseUrl}/version/update`, qs.stringify(params)).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //灰度发布
    grayscaleRelease: params => {
        return axios.post(`${_baseUrl}/version/scale/publish`, qs.stringify(params)).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //发布版本/设置为当前版本
    currentVersion: params => {
        return axios.post(`${_baseUrl}/version/publish`, qs.stringify(params)).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
    //操作日志
    commitLog: params => {
        return axios.get(`${_baseUrl}/log/list`, {
            params: params
        }).then(response => {
            // 返回后端返回数据
            return response.data
        }).catch(error => {
            // 异常处理
            message.error("服务器开小差了⊙﹏⊙");
        })
    },
}